exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".clozePage .finishedButton{color:#fff;background-color:#2b9401;border:1px solid #237600;padding:6px 12px;font-size:1em;border-radius:5px;font-family:museo-sans-rounded,Helvetica,Arial,sans-serif;min-width:100px!important}.clozePage .finishedButton:hover{color:#fff;background-color:#237600;border-color:#195500}.clozePage .Cloze-Passage{max-width:65rem;margin:0 auto}.clozePage .finishedButton{margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/cloze/cloze_page.scss
// module id = 1253
// module chunks = 0